// @ts-expect-error Untyped import
import { isResolved } from 'reference-resolvers/utils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error Untyped import
import { provideBusinessUnitDropdown } from '../../../utils/businessUnitUtils';
// @ts-expect-error Untyped import
import { mapReferenceResolverToPlainJS } from '../../../utils/businessUnitUtils';
// @ts-expect-error Untyped import
import { getBusinessUnitId } from 'reporting-action-components/data/schemas/reportSchema';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportBusinessUnitName = ({
  report
}) => {
  const businessUnitId = getBusinessUnitId(report);
  const BusinessUnitNameWrapper = provideBusinessUnitDropdown(({
    buOptions
  }) => {
    const _buOptions = mapReferenceResolverToPlainJS(buOptions);
    if (isResolved(_buOptions) && _buOptions.length !== 0) {
      const currentBusinessUnit = (_buOptions || []).find(({
        id
      }) => id === businessUnitId);
      const businessUnitName = currentBusinessUnit.name;
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reports.reportCard.details.businessUnit",
        options: {
          brand: businessUnitName
        }
      });
    }
    return null;
  });
  return /*#__PURE__*/_jsx(BusinessUnitNameWrapper, {});
};